var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.34 8.17C12.41 8.17 11.65 7.4 11.65 6.47C11.65 6.02178 11.8281 5.59193 12.145 5.27499C12.4619 4.95805 12.8918 4.78 13.34 4.78C14.28 4.78 15.04 5.54 15.04 6.47C15.04 7.4 14.28 8.17 13.34 8.17M10.3 19.93L4.37 18.75L4.71 17.05L8.86 17.9L10.21 11.04L8.69 11.64V14.5H7V10.54L11.4 8.67L12.07 8.59C12.67 8.59 13.17 8.93 13.5 9.44L14.36 10.79C15.04 12 16.39 12.82 18 12.82V14.5C16.14 14.5 14.44 13.67 13.34 12.4L12.84 14.94L14.61 16.63V23H12.92V17.9L11.14 16.21L10.3 19.93M21 23H19V3H6V16.11L4 15.69V1H21V23ZM6 23H4V19.78L6 20.2V23Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.c9fdb090c527fb80eaeb5ea91a6b6528.svg";
export { ForwardRef as ReactComponent };